import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { BearerTokenContext } from '../services/context/BearerTokenContext.js';
import useApis from '../services/hooks/useApis.js';
import { LimitsContext, UpdateLimitsContext } from '../services/context/LimitsContext.js';
import { SubscriptionDetailsContext } from '../services/context/SubscriptionDetailsContext.js';

/**
 *
 * @param root0
 * @param root0.slot
 */
export default function LimitsController({ slot }) {
  const [limits, setLimits] = useState();
  const bearerToken = useContext(BearerTokenContext);
  const { getSubscriberLimits } = useApis();
  const subscriptionDetails = useContext(SubscriptionDetailsContext);
  const billingFrequency = subscriptionDetails?.subscribedPlan?.billingFrequency || null;

  useEffect(() => {
    if (bearerToken && subscriptionDetails) {
      getSubscriberLimits({
        bearerToken,
        billingFrequency,
      })
        .then(response => {
          if (response?.data?.limits) {
            setLimits(response.data.limits);
          } else {
            setLimits([]);
          }
        })
        .catch(() => setLimits(null));
    }
  }, [
    bearerToken,
    subscriptionDetails,
  ]);

  return (
    <LimitsContext.Provider value={ limits }>
      <UpdateLimitsContext.Provider value={ setLimits }>
        {slot}
      </UpdateLimitsContext.Provider>
    </LimitsContext.Provider>
  );
}

LimitsController.propTypes = { slot: PropTypes.element };
